<template>
    <div id="panel-description" class="panel vh-225">
        <div   class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Оголошення Редукціон № {{reduction.number}}
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            
            <div class="panel-content">
                <div><span v-html="reduction.description"></span></div>
            </div>
        </div>
    </div>
</template>

<script>


import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'reduction/getReductionField',
    mutationType: 'reduction/updateReductionField',
});

export default {
    name: "reduction_description",
    computed: {
        ...mapFields([
            'reduction',
        ]),
    }
}
</script>


<style scoped>

</style>